import styled from "styled-components/native";
import Text from "./text";
import { color, font } from "../theme";

export const ErrorText = styled(Text)`
  font-family: ${font.defaultBold};
  color: ${color.primary};
`;
